module.exports = __webpack_public_path__ + "static/img/7.ce5a1cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/7.jpg
// module id = utV+
// module chunks = 1